var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 768,
    viewBox: "0 0 204 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "difference"
    },
    opacity: 0.78
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2420_11061",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -97,
    y: 0,
    width: 434,
    height: 771
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M337 771L337 0L-97 -1.89707e-05L-97 771L337 771Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2420_11061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2618.57 989.436C-2677.52 970.066 -313.083 1302.55 -112.151 691.914C88.7803 81.2755 1306.28 729.798 1365.23 749.168C1424.18 768.537 1075.84 -4.49617 874.907 606.142C673.975 1216.78 -2559.62 1008.8 -2618.57 989.436Z",
    fill: "url(#paint0_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2381.83 1034.33C-2440.78 1014.97 -304.156 1249.44 -103.224 638.801C97.7075 28.1629 1200.07 584.155 1259.02 603.524C1317.96 622.893 1055.44 -60.6127 854.506 550.026C653.574 1160.66 -2322.88 1053.7 -2381.83 1034.33Z",
    fill: "url(#paint1_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2145.71 1069.91C-2204.66 1050.54 -295.855 1187 -94.9235 576.363C106.008 -34.2756 1093.22 429.186 1152.17 448.555C1211.12 467.925 1034.41 -126.055 833.479 484.584C632.548 1095.22 -2086.77 1089.28 -2145.71 1069.91Z",
    fill: "url(#paint2_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1911.14 1097.99C-1970.09 1078.62 -289.093 1117.07 -88.1612 506.434C112.77 -104.204 984.843 266.727 1043.79 286.096C1102.74 305.466 1011.85 -198.987 810.914 411.652C609.982 1022.29 -1852.19 1117.36 -1911.14 1097.99Z",
    fill: "url(#paint3_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1680.95 1127.52C-1739.9 1108.15 -286.722 1048.59 -85.7907 437.951C115.141 -172.687 872.07 105.713 931.018 125.083C989.966 144.452 984.888 -270.474 783.956 340.165C583.025 950.803 -1622.01 1146.89 -1680.95 1127.52Z",
    fill: "url(#paint4_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1460.33 1160.4C-1519.27 1141.03 -293.907 983.455 -92.9748 372.816C107.957 -237.822 749.742 -51.9519 808.69 -32.5828C867.639 -13.2136 948.376 -338.612 747.445 272.026C546.513 882.664 -1401.38 1179.77 -1460.33 1160.4Z",
    fill: "url(#paint5_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1249.47 1198.13C-1308.42 1178.76 -310.866 923.176 -109.934 312.538C90.9971 -298.1 617.638 -204.761 676.587 -185.392C735.535 -166.022 902.089 -401.894 701.158 208.744C500.226 819.383 -1190.52 1217.5 -1249.47 1198.13Z",
    fill: "url(#paint6_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1044.48 1244.26C-1103.43 1224.89 -333.684 871.29 -132.753 260.652C68.179 -349.987 479.676 -349.177 538.625 -329.808C597.573 -310.439 849.944 -456.784 649.012 153.855C448.08 764.493 -985.528 1263.63 -1044.48 1244.26Z",
    fill: "url(#paint7_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-842.525 1300.58C-901.474 1281.21 -359.546 829.597 -158.614 218.959C42.3177 -391.68 338.671 -483.401 397.619 -464.032C456.568 -444.663 794.754 -501.481 593.822 109.158C392.891 719.796 -783.577 1319.95 -842.525 1300.58Z",
    fill: "url(#paint8_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-641.738 1357.98C-700.686 1338.61 -386.572 788.99 -185.64 178.352C15.2919 -432.286 196.501 -616.538 255.45 -597.169C314.398 -577.8 738.401 -545.091 537.469 65.5478C336.538 676.186 -582.789 1377.35 -641.738 1357.98Z",
    fill: "url(#paint9_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-438.077 1415.65C-497.025 1396.28 -410.724 748.648 -209.792 138.009C-8.86 -472.629 57.2057 -749.412 116.154 -730.042C175.103 -710.673 684.921 -588.437 483.99 22.2012C283.058 632.84 -379.128 1435.02 -438.077 1415.65Z",
    fill: "url(#paint10_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-198.01 1473.41C-256.959 1454.04 -398.47 708.393 -197.539 97.7549C3.39311 -512.883 -45.685 -882.196 13.2634 -862.827C72.2119 -843.458 667.847 -631.695 466.915 -21.0564C265.984 589.582 -139.062 1492.78 -198.01 1473.41Z",
    fill: "url(#paint11_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3395 1531.2C31.391 1511.84 -337.934 668.177 -137.002 57.5388C63.9296 -553.099 -100.292 -1014.94 -41.3439 -995.574C17.6046 -976.205 699.056 -674.915 498.124 -64.2764C297.192 546.362 149.288 1550.57 90.3395 1531.2Z",
    fill: "url(#paint12_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.591 1589.02C332.642 1569.65 -264.496 627.98 -63.5641 17.342C137.367 -593.296 -141.998 -1147.67 -83.0496 -1128.3C-24.1012 -1108.93 743.166 -718.115 542.234 -107.477C341.303 503.162 450.539 1608.39 391.591 1589.02Z",
    fill: "url(#paint13_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.179 1646.85C651.231 1627.48 -173.72 587.795 27.2114 -22.8437C228.143 -633.482 -166.366 -1280.39 -107.418 -1261.02C-48.4695 -1241.65 804.614 -761.304 603.682 -150.666C402.751 459.972 769.128 1666.22 710.179 1646.85Z",
    fill: "url(#paint14_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M948.395 1704.68C889.447 1685.31 -163.318 547.615 37.6141 -63.0227C238.546 -673.661 -271.107 -1413.1 -212.159 -1393.73C-153.211 -1374.36 785.689 -804.487 584.757 -193.849C383.826 416.79 1007.34 1724.05 948.395 1704.68Z",
    fill: "url(#paint15_radial_2420_11061)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.12 1762.52C1127.17 1743.15 -153.409 507.441 47.5225 -103.197C248.454 -713.835 -376.343 -1545.8 -317.394 -1526.43C-258.446 -1507.06 766.27 -847.665 565.338 -237.027C364.407 373.611 1245.07 1781.89 1186.12 1762.52Z",
    fill: "url(#paint16_radial_2420_11061)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-299.03 908.686 -1632.7 -536.507 -582.332 740.166)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-283.826 862.487 -1549.69 -509.23 -523.189 709.795)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-270.068 820.678 -1474.57 -484.545 -464.121 669.271)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-258.039 784.124 -1408.89 -462.964 -405.688 620.364)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-248.096 753.91 -1354.6 -445.124 -349.626 572.159)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-240.959 732.221 -1315.63 -432.319 -293.462 528.798)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-238.069 723.441 -1299.85 -427.135 -209.13 500.754)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-237.101 720.497 -1294.57 -425.397 -127.819 479.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-238.067 723.433 -1299.84 -427.13 -49.3743 465.905)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-241.131 732.746 -1316.57 -432.628 25.2843 449.121)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-247.499 752.095 -1351.34 -444.053 27.9644 404.57)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-256.308 778.866 -1399.44 -459.859 -20.9798 328.751)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-267.044 811.489 -1458.06 -479.12 26.8578 268.591)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-280.779 853.225 -1533.05 -503.762 154.209 230.339)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-296.047 899.623 -1616.41 -531.156 300.952 192.774)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-312.592 949.899 -1706.75 -560.841 367.622 155.313)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_2420_11061",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-330.217 1003.46 -1802.98 -592.462 433.869 117.881)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0049D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarBg);
export default __webpack_public_path__ + "static/media/sidebar-bg.047029fbc326c6ba195718e5d9c8736d.svg";
export { ForwardRef as ReactComponent };